import React, { LabelHTMLAttributes } from "react";

type InputProps = LabelHTMLAttributes<HTMLLabelElement> & {
  label: string;
  required?: boolean;
};

export const Label = React.forwardRef<HTMLLabelElement, InputProps>(
  (props, ref) => {
    const { label, id, htmlFor, required, ...rest } = props;
    // Callers pass either `htmlFor` or (legacy) `id` for the control they label.
    return (
      <label
        className="text-gray-700"
        {...rest}
        ref={ref}
        htmlFor={htmlFor ?? id}
      >
        {label}
        {required && (
          <span
            className="text-danger custom-required-text"
            style={{ fontSize: 17 }}
          >
            *
          </span>
        )}
      </label>
    );
  }
);
